import { render, staticRenderFns } from "./StaffInputForm.vue?vue&type=template&id=5a02fe9d&scoped=true&"
import script from "./StaffInputForm.vue?vue&type=script&lang=js&"
export * from "./StaffInputForm.vue?vue&type=script&lang=js&"
import style0 from "./StaffInputForm.vue?vue&type=style&index=0&id=5a02fe9d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a02fe9d",
  null
  
)

export default component.exports